import { render } from "./RoomControl.vue?vue&type=template&id=471ecd5d"
import script from "./RoomControl.vue?vue&type=script&lang=js"
export * from "./RoomControl.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__